<template>
  <div class="home-description-wrapper">
    <div class="home-description">
      <div v-for="{title, text} of items" :key="title">
        <p>{{ title }}</p>
        <span v-html="text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeDescription',
  setup() {

    const items = [
      {
        title: 'Индивидуальный подход',
        text: 'Разрабатываем индивидуальные условия транспортировки, исходя из характера груза и пожеланий каждого клиента'
      },
      {
        title: 'Технологические решения',
        text: 'Используем современные технологии в работе для максимальной автоматизации и обеспечения прозрачности логистических процессов'
      },
      {
        title: 'Дополнительные возможности',
        text: 'Комплекс дополнительных услуг для ваших отправлений: различные виды упаковки, погрузо-разгрузочные работы, ответственное хранение и страхование'
      },
    ]

    return {
      items,
    }
  }
}
</script>

<style scoped>
.home-description-wrapper {
  width: 100%;
  padding-top: 66px;
  padding-bottom: 72px;
  background-image: url("../assets/description-bg.png");
  background-position: center;
  background-size: cover;
}

.home-description {
  width: 97%;
  max-width: 1240px;
  display: flex;
  margin: auto;
  row-gap: 24px;
  column-gap: 92px;
  text-align: left;
}

.home-description p {
  color: white;
  font-size: 22px;
  font-weight: 600;
}

.home-description span {
  color: var(--font-4);
  font-size: 16px;
}

@media screen and (max-width: 1200px) {
  .home-description-wrapper {
    padding-top: 28px;
    padding-bottom: 44px;
    background-image: url("../assets/description-bg-sm.png");
  }
  .home-description {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .home-description {
    max-width: 1240px;
  }
}
</style>
